import Vue from 'vue'

import ScrollTo from '@/mixins/ScrollTo'

export default () => {
  Vue.mixin(ScrollTo)
}
